import lodash from "lodash";
import { defineAsyncComponent } from "vue";
import { Form } from "ant-design-vue";
import {
    createFieldDate,
    createFieldDatetime,
    createFieldInput, createFieldInputNumber,
    createFieldSelect
} from "../../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../../i18n";
import store from "../../../../../../store";
import { conditionFormChecker, putField } from "../../../../../../utils/form";
import { createForm, initDefaultForm } from "./sampling-info.logic";

const CSelect = defineAsyncComponent(() => import("../../../../../../components/input/template-builder/select/CSelect"));
const SamplingDistributorList = defineAsyncComponent(() => import("../../../release/request/sampling-distributors/SamplingDistributorList"));

export const callOperation = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_OBJECTIVE", value: searchQuery });
export const callQuantityUnit = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "QUANTITY_UNIT", value: searchQuery });

export const createField = ({ props, data, key }) => {
    const { viewOnly, informProduct, menuContext, dataKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;

    if (key && !lodash.get(modelRef, key)) {
        lodash.set(modelRef, key, createForm());
    }
    const model = initDefaultForm({ props, data, key });
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldDatetime({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}samplingDatetime`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => `${i18n.global.t("model.sampling.samplingDatetime")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.samplingDatetime,
                            "onUpdate:value": value => {
                                model.samplingDatetime = value;
                                model.isSave = true;
                                informProduct?.setSamplings?.({ modelRef, id: informProduct?.id, samplings: [model] })
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
            },
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refOperation`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => `${i18n.global.t("model.sampling.refOperation")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.refOperation,
                            "onUpdate:value": value => {
                                model.refOperation = value;
                                model.isSave = true;
                                informProduct?.setSamplings?.({ modelRef, id: informProduct?.id, samplings: [model] })
                            },
                            disabled: true,
                            list: callOperation,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
            },
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}manufactureDate`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => `${i18n.global.t("model.sampling.manufactureDate")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.manufactureDate,
                            "onUpdate:value": value => {
                                model.manufactureDate = value;
                                model.isSave = true;
                                informProduct?.setSamplings?.({ modelRef, id: informProduct?.id, samplings: [model] })
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}manufactureExpireDate`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.sampling.manufactureExpireDate")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.manufactureExpireDate,
                            "onUpdate:value": value => {
                                model.manufactureExpireDate = value;
                                model.isSave = true;
                                informProduct?.setSamplings?.({ modelRef, id: informProduct?.id, samplings: [model] })
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}manufacturer`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 5 }, wrapperCol: { xs: 24, md: 19 } }),
                label: () => `${i18n.global.t("model.sampling.manufacturer")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.manufacturer,
                            "onUpdate:value": value => {
                                model.manufacturer = value;
                                model.isSave = true;
                                informProduct?.setSamplings?.({ modelRef, id: informProduct?.id, samplings: [model] })
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                    key: `${prefix}importer`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 5 }, wrapperCol: { xs: 24, md: 19 } }),
                label: () => `${i18n.global.t("model.sampling.importer")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.importer,
                            "onUpdate:value": value => {
                                model.importer = value;
                                model.isSave = true;
                                informProduct?.setSamplings?.({ modelRef, id: informProduct?.id, samplings: [model] })
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                    key: `${prefix}distributor`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 5 }, wrapperCol: { xs: 24, md: 19 } }),
                label: () => `${i18n.global.t("model.sampling.distributor")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.distributor,
                            "onUpdate:value": value => {
                                model.distributor = value;
                                model.isSave = true;
                                informProduct?.setSamplings?.({ modelRef, id: informProduct?.id, samplings: [model] })
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}SamplingDistributorList`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: true,
                            dataProp: data,
                            itemsKey: `${prefix}distributors`,
                            canCreate: false,
                            canDelete: false,
                            inspectionKey: dataKey,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "SamplingDistributorList" } })
                    );
                    return <SamplingDistributorList {...componentProp}></SamplingDistributorList>;
                }
            },
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}size`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => i18n.global.t("model.sampling.size"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.size,
                            "onUpdate:value": value => {
                                model.size = value;
                                model.isSave = true;
                                informProduct?.setSamplings?.({ modelRef, id: informProduct?.id, samplings: [model] })
                            },
                            disabled: viewOnly,
                            allowPrecision: true,
                            addonAfter: () => {
                                const addonAfterProp = lodash.merge(
                                    {
                                        value: model?.refSizeUnit,
                                        "onUpdate:value": value => {
                                            model.refSizeUnit = value;
                                            model.isSave = true;
                                            informProduct?.setSamplings?.({ modelRef, id: informProduct?.id, samplings: [model] })
                                        },
                                        disabled: viewOnly,
                                        list: callQuantityUnit,
                                        optLabel: "value",
                                        placeholder: i18n.global.t("button.unit"),
                                        style: { width: "100px !important" }
                                    },
                                    conditionFormChecker({
                                        props,
                                        data,
                                        executeKey: "inputPropField",
                                        params: { field: { key: `${prefix}refSizeUnit` }, model }
                                    })
                                );
                                return (
                                    <Form.Item {...useForm.validateInfos[`${prefix}refSizeUnit`]} help={undefined}>
                                        <CSelect {...addonAfterProp}></CSelect>
                                    </Form.Item>
                                );
                            }
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}qty`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.sampling.qty"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.qty,
                            "onUpdate:value": value => {
                                model.qty = value;
                                model.isSave = true;
                                informProduct?.setSamplings?.({ modelRef, id: informProduct?.id, samplings: [model] })
                            },
                            disabled: viewOnly,
                            allowPrecision: true,
                            addonAfter: () => {
                                const addonAfterProp = lodash.merge(
                                    {
                                        value: model?.refQtyUnit,
                                        "onUpdate:value": value => {
                                            model.refQtyUnit = value;
                                            model.isSave = true;
                                            informProduct?.setSamplings?.({ modelRef, id: informProduct?.id, samplings: [model] })
                                        },
                                        disabled: viewOnly,
                                        list: callQuantityUnit,
                                        optLabel: "value",
                                        placeholder: i18n.global.t("button.unit"),
                                        style: { width: "100px !important" }
                                    },
                                    conditionFormChecker({
                                        props,
                                        data,
                                        executeKey: "inputPropField",
                                        params: { field: { key: `${prefix}refQtyUnit` }, model }
                                    })
                                );
                                return (
                                    <Form.Item {...useForm.validateInfos[`${prefix}refQtyUnit`]} help={undefined}>
                                        <CSelect {...addonAfterProp}></CSelect>
                                    </Form.Item>
                                );
                            }
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    )
            }),
        ]
    });
};
